import React, { useContext, useState } from "react";
import { assets } from "../assets/assets";
import { Link, NavLink } from "react-router-dom";
import { ShopContext } from "../context/ShopContext";
import { IoSearchCircle } from "react-icons/io5";
import { LuUser } from "react-icons/lu";
import { SlHandbag } from "react-icons/sl";
import { Helmet } from "react-helmet-async";

const Navbar = () => {
  const [visible, setVisible] = useState(false);
  // const [dropdownVisible, setDropdownVisible] = useState(false);

  const {
    setShowSearch,
    getCartCount,
    navigate,
    token,
    setToken,
    setCartItems
  } = useContext(ShopContext);

  const logout = () => {
    navigate("/login");
    localStorage.removeItem("token");
    setToken("");
    setCartItems({});
  };

  const handleProfileClick = () => {
    if (!token) {
      navigate("/login");
    } else {
      setDropdownVisible((prevState) => !prevState);
    }
  };

  return (
    <header>
      {/* Metadata for Navbar
     <Helmet>
        <title>{`My E-commerce | Navbar`}</title>
        <meta name="description" content="Navigate through our amazing collections and shop effortlessly." />
      </Helmet> */}
      {/* Top Section */}
      {!token && (
        <div className="sticky top-0 z-10 bg-gradient-to-r from-[#FF4902] to-[#FF4902] h-10 flex justify-between items-center px-5">
          <div></div>
          <div className="flex items-center justify-center space-x-2 sm:space-x-4">
            <p className="text-white text-xs sm:text-xs">
              {" "}
              Free shipping all over India.At min order of ₹500 and above
            </p>

            <Link
              to="/login"
              className="bg-white text-black hover:bg-orange-200 px-2 py-1 text-xs rounded whitespace-nowrap "
            >
              Shop now
            </Link>
            {/* <Link to="/shop" className="bg-white text-black font-extrabold hover:bg-orange-200 px-2 py-1 text-xs rounded">
            Shop Now
          </Link> */}
          </div>
          <div className="space-x-2 flex ml-2">
            <>
              <Link
                to="/login"
                className="bg-white text-black hover:bg-orange-200 px-2 py-1 text-xs rounded"
              >
                Login
              </Link>
            </>
          </div>
        </div>
      )}

      {/* Main Navbar */}
      <div className="flex items-center justify-between py-9 px-4 lg:px-7 lg:h-16 h-16">
        {/* Logo */}
        <Link to="/">
          <img
             src= "https://res.cloudinary.com/dypkxqirq/image/upload/v1759906597/logo-BKlRXsJu_1_cf5loj.webp" //{assets.logo}
            className="w-40 h-12 sm:w-64 sm:h-16 md:w-56 md:h-16 lg:w-64 lg:h-16 object-contain max-w-full max-h-16"
            alt="Logo"
          />
        </Link>

        {/* https://res.cloudinary.com/djqeoutoy/image/upload/v1735385641/d66cfhlbbtewrphuxhva.webp */}

        <ul className="hidden sm:flex gap-4 sm:gap-10 md:gap-8 lg:gap-16 xl:gap-12 text-sm sm:text-base md:text-lg lg:text-xl font-semibold text-gray-700">
          {[
            { name: "Home", path: "/" },
            { name: "Men", path: "/men" },
            { name: "Women", path: "/women" },
             { name: "Kids", path: "/kids" },
            { name: "Collection", path: "/collection" }
            // { name: "Customize", path: "/customize" },

            // { name: "About Us", path: "/about" },
            // { name: "Contact Us", path: "/contact" },
          ].map((link) => (
            <li
              key={link.path}
              className="h-6 md:h-8 lg:h-10 flex items-center"
            >
              <NavLink
                to={link.path}
                className={({ isActive }) =>
                  `relative transition-all duration-300 hover:text-[#FF4902] ${
                    isActive
                      ? "text-[#FF4902] font-bold scale-125"
                      : "text-black"
                  }`
                }
              >
                {link.name}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Icons */}
        <div className="flex items-center gap-3 sm:gap-2">
          <div
            onClick={() => {
              setShowSearch(true);
              navigate("/collection");
            }}
            className="cursor-pointer"
          >
            <IoSearchCircle
              className="text-[#FF4902] w-10 h-10" // Adjust size and color here
              style={{ color: "[#FF4902]" }} // Ensure the outer color is orange
            />
          </div>
          <div className="relative">
            <div
              onClick={handleProfileClick}
              className="w-8 h-8 bg-[#FF4902] rounded-full flex items-center justify-center cursor-pointer"
            >
              <Link
                to="/profile"
                className="block px-4 py-1 text-gray-600 hover:text-[#FF4902]"
              >
                <LuUser className="text-white w-5 h-5" />
              </Link>
            </div>
            {/* {dropdownVisible && token && (
              <div className="absolute right-0 mt-2 w-36 py-2 bg-white shadow-lg rounded-lg z-20">
                <Link to="/profile" className="block px-4 py-1 text-gray-600 hover:text-[#FF4902]">My Profile</Link>
                <p onClick={() => navigate('/orders')} className="block px-4 py-1 text-gray-600 hover:text-[#FF4902] cursor-pointer">Orders</p>
                <p onClick={logout} className="block px-4 py-1 text-gray-600 hover:text-[#FF4902] cursor-pointer">Logout</p>
              </div>
            )} */}
          </div>
          <Link to="/cart" className="relative">
            <div className="w-8 h-8 bg-[#FF4902] rounded-full flex items-center justify-center cursor-pointer">
              <SlHandbag className="text-white w-4 h-4" />
            </div>
            <p className="absolute -top-1 -right-1 w-4 h-4 bg-black text-white text-xs rounded-full flex items-center justify-center">
              {getCartCount()}
            </p>
          </Link>
          {/* Hamburger Menu */}
          <img
            onClick={() => setVisible(true)}
            src={assets.menu_icon}
            className="w-5 cursor-pointer sm:hidden"
            alt="Menu"
          />
        </div>

        {/* Sidebar for Small Devices */}
        <div
          className={`fixed top-0 right-0 bottom-0 z-30 bg-white transition-transform ${
            visible ? "translate-x-0" : "translate-x-full"
          } w-3/4 sm:w-1/2 md:w-1/3`}
        >
          <div className="flex flex-col h-full text-gray-700">
            <div
              onClick={() => setVisible(false)}
              className="flex items-center gap-2 p-4 cursor-pointer border-b"
            >
              <img
                className="w-4 rotate-180"
                src={assets.dropdown_icon}
                alt="Close"
              />
              <p>Back</p>
            </div>
            <NavLink
              onClick={() => setVisible(false)}
              to="/"
              className="py-3 px-4 border-b"
            >
              HOME
            </NavLink>
            <NavLink
              onClick={() => setVisible(false)}
              to="/men"
              className="py-3 px-4 border-b"
            >
              Men
            </NavLink>
            <NavLink
              onClick={() => setVisible(false)}
              to="/women"
              className="py-3 px-4 border-b"
            >
              Women
            </NavLink>
            <NavLink
              onClick={() => setVisible(false)}
              to="/kids"
              className="py-3 px-4 border-b"
            >
              Kids
            </NavLink>
            <NavLink
              onClick={() => setVisible(false)}
              to="/collection"
              className="py-3 px-4 border-b"
            >
              COLLECTION
            </NavLink>
            {/* <NavLink onClick={() => setVisible(false)} to="/customize" className="py-3 px-4 border-b">CUSTOMIZE</NavLink> */}
            <NavLink
              onClick={() => setVisible(false)}
              to="/about"
              className="py-3 px-4 border-b"
            >
              ABOUT US
            </NavLink>
            <NavLink
              onClick={() => setVisible(false)}
              to="/contact"
              className="py-3 px-4 border-b"
            >
              CONTACT US
            </NavLink>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;

// import React, { useContext, useState } from 'react';
// import { assets } from '../assets/assets';
// import { Link, NavLink } from 'react-router-dom';
// import { ShopContext } from '../context/ShopContext';
// import { IoSearchCircle } from "react-icons/io5";
// import { LuUser } from "react-icons/lu";
// import { SlHandbag } from "react-icons/sl";
// import { Helmet } from 'react-helmet-async';

// const Navbar = () => {
//   const [visible, setVisible] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);

//   const { setShowSearch, getCartCount, navigate, token, setToken, setCartItems } = useContext(ShopContext);

//   const logout = () => {
//     navigate('/login');
//     localStorage.removeItem('token');
//     setToken('');
//     setCartItems({});
//   };

//   return (
//     <header>
//       {!token && (
//         <div className="sticky top-0 z-10 bg-gradient-to-r from-[#FF4902] to-[#FF4902] h-10 flex justify-between items-center px-5">
//           <div></div>
//           <div className="flex items-center justify-center space-x-2 sm:space-x-4">
//             <p className="text-white text-xs sm:text-xs">Free shipping all over India. At min order of ₹500 and above</p>
//             <Link to="/login" className="bg-white text-black hover:bg-orange-200 px-2 py-1 text-xs rounded whitespace-nowrap">Shop now</Link>
//           </div>
//           <div className="space-x-2 flex ml-2">
//             <Link to="/login" className="bg-white text-black hover:bg-orange-200 px-2 py-1 text-xs rounded">Login</Link>
//           </div>
//         </div>
//       )}

//       <div className="flex items-center justify-between py-9 px-4 lg:px-7 lg:h-16 h-16">
//         <Link to="/">
//           <img
//             src={assets.logo}
//             className="w-40 h-12 sm:w-64 sm:h-16 md:w-56 md:h-16 lg:w-64 lg:h-16 object-contain max-w-full max-h-16"
//             alt="Logo"
//           />
//         </Link>

//         <ul className="hidden sm:flex gap-4 sm:gap-10 md:gap-8 lg:gap-16 xl:gap-12 text-sm sm:text-base md:text-lg lg:text-xl font-semibold text-gray-700">
//           <li className="h-6 md:h-8 lg:h-10 flex items-center">
//             <NavLink to="/" className={({ isActive }) =>
//               `relative transition-all duration-300 hover:text-[#FF4902] ${isActive ? "text-[#FF4902] font-bold scale-125" : "text-black"}`
//             }>
//               Home
//             </NavLink>
//           </li>
//           <li className="h-6 md:h-8 lg:h-10 flex items-center">
//             <NavLink to="/collection" className={({ isActive }) =>
//               `relative transition-all duration-300 hover:text-[#FF4902] ${isActive ? "text-[#FF4902] font-bold scale-125" : "text-black"}`
//             }>
//               Collection
//             </NavLink>
//           </li>
//           <li className="relative h-6 md:h-8 lg:h-10 flex items-center cursor-pointer"
//               onMouseEnter={() => setShowDropdown(true)}
//               onMouseLeave={() => setShowDropdown(false)}>
//             <span className="relative transition-all duration-300 hover:text-[#FF4902] text-black">
//               Categories
//             </span>
//             {showDropdown && (
//               <ul className="absolute top-full left-0 bg-white shadow-lg rounded mt-1 z-20 text-sm">
//                 <li>
//                   <NavLink to="/mens" className="block px-4 py-2 hover:bg-gray-100">Mens</NavLink>
//                 </li>
//                 <li>
//                   <NavLink to="/womens" className="block px-4 py-2 hover:bg-gray-100">Womens</NavLink>
//                 </li>
//                 <li>
//                   <NavLink to="/kids" className="block px-4 py-2 hover:bg-gray-100">Kids</NavLink>
//                 </li>
//               </ul>
//             )}
//           </li>
//           <li className="h-6 md:h-8 lg:h-10 flex items-center">
//             <NavLink to="/about" className={({ isActive }) =>
//               `relative transition-all duration-300 hover:text-[#FF4902] ${isActive ? "text-[#FF4902] font-bold scale-125" : "text-black"}`
//             }>
//               About Us
//             </NavLink>
//           </li>
//           <li className="h-6 md:h-8 lg:h-10 flex items-center">
//             <NavLink to="/contact" className={({ isActive }) =>
//               `relative transition-all duration-300 hover:text-[#FF4902] ${isActive ? "text-[#FF4902] font-bold scale-125" : "text-black"}`
//             }>
//               Contact Us
//             </NavLink>
//           </li>
//         </ul>

//         <div className="flex items-center gap-3 sm:gap-2">
//           <div onClick={() => {
//             setShowSearch(true);
//             navigate('/collection');
//           }} className="cursor-pointer">
//             <IoSearchCircle className="text-[#FF4902] w-10 h-10" />
//           </div>
//           <div className="relative">
//             <Link to="/profile">
//               <div className="w-8 h-8 bg-[#FF4902] rounded-full flex items-center justify-center cursor-pointer">
//                 <LuUser className="text-white w-5 h-5" />
//               </div>
//             </Link>
//           </div>
//           <Link to="/cart" className="relative">
//             <div className="w-8 h-8 bg-[#FF4902] rounded-full flex items-center justify-center cursor-pointer">
//               <SlHandbag className="text-white w-4 h-4" />
//             </div>
//             <p className="absolute -top-1 -right-1 w-4 h-4 bg-black text-white text-xs rounded-full flex items-center justify-center">
//               {getCartCount()}
//             </p>
//           </Link>
//           <img onClick={() => setVisible(true)} src={assets.menu_icon} className="w-5 cursor-pointer sm:hidden" alt="Menu" />
//         </div>

//         <div className={`fixed top-0 right-0 bottom-0 z-30 bg-white transition-transform ${visible ? 'translate-x-0' : 'translate-x-full'} w-3/4 sm:w-1/2 md:w-1/3`}>
//           <div className="flex flex-col h-full text-gray-700">
//             <div onClick={() => setVisible(false)} className="flex items-center gap-2 p-4 cursor-pointer border-b">
//               <img className="w-4 rotate-180" src={assets.dropdown_icon} alt="Close" />
//               <p>Back</p>
//             </div>
//             <NavLink onClick={() => setVisible(false)} to="/" className="py-3 px-4 border-b">HOME</NavLink>
//             <NavLink onClick={() => setVisible(false)} to="/collection" className="py-3 px-4 border-b">COLLECTION</NavLink>
//             <NavLink onClick={() => setVisible(false)} to="/mens" className="py-3 px-4 border-b">MENS</NavLink>
//             <NavLink onClick={() => setVisible(false)} to="/womens" className="py-3 px-4 border-b">WOMENS</NavLink>
//             <NavLink onClick={() => setVisible(false)} to="/kids" className="py-3 px-4 border-b">KIDS</NavLink>
//             <NavLink onClick={() => setVisible(false)} to="/about" className="py-3 px-4 border-b">ABOUT US</NavLink>
//             <NavLink onClick={() => setVisible(false)} to="/contact" className="py-3 px-4 border-b">CONTACT US</NavLink>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Navbar;
